import { render } from "./ItemSpecs.vue?vue&type=template&id=50f47312&scoped=true&ts=true"
import script from "./ItemSpecs.vue?vue&type=script&lang=ts"
export * from "./ItemSpecs.vue?vue&type=script&lang=ts"

import "./ItemSpecs.vue?vue&type=style&index=0&id=50f47312&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f47312"]])

export default __exports__